/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvat131Inputs */

const en_ticketsvat131 = /** @type {(inputs: Ticketsvat131Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13%`)
};

const de_ticketsvat131 = /** @type {(inputs: Ticketsvat131Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13 %`)
};

/**
* | output |
* | --- |
* | "13%" |
*
* @param {Ticketsvat131Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvat131 = /** @type {((inputs?: Ticketsvat131Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvat131Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvat131(inputs)
	return de_ticketsvat131(inputs)
});
export { ticketsvat131 as "ticketsVat13" }